import React, { useState } from 'react';

const News = () => {
  const [inputWord, setInputWord] = useState('');
  const [resultPhrase, setResultPhrase] = useState('');
  const [fetchedData, setFetchedData] = useState('');

  const handleInputChange = (e) => {
    setInputWord(e.target.value);
  };

  const searchPhrase = () => {
    fetch(`/Chumash-Processed2.txt`)
      .then((response) => response.text())
      .then((text) => {
        const lines = text.split('\n');
        const inputLetters = inputWord.split('');

        for (const line of lines) {
          const wordsInLine = line.split(' ');

          for (let startIndex = 0; startIndex <= wordsInLine.length - inputLetters.length; startIndex++) {
            let match = true;
            let matchedPhrase = [];

            for (let i = 0; i < inputLetters.length; i++) {
              const matchingLetter = getMatchingLetter(inputLetters[i]);
              const word = wordsInLine[startIndex + i];

              if (word && word.startsWith(matchingLetter)) {
                matchedPhrase.push(word);
              } else {
                match = false;
                break;
              }
            }

            if (match) {
              setResultPhrase(matchedPhrase.join(' '));
              searchCitation(matchedPhrase.join(' '));
              return;
            }
          }
        }

        setResultPhrase('No matching phrase found');
      });
  };

  const searchCitation = (phrase) => {
    fetch(`https://bolls.life/search/WLCC/?search=${phrase}&match_case=false&match_whole=true`)
      .then((response) => response.json())
      .then((data) => {
        const formattedData = data.map((item) => {
          if (item.book) { // Add this check
            return {
              citation: `${getBookName(item.book.toString())} ${item.chapter}:${item.verse}`,
            };
          }
          return null; // Return null if item.book is not defined
        });
        // Remove null entries from formattedData array
        const filteredData = formattedData.filter(item => item !== null);
        setFetchedData(JSON.stringify(filteredData, null, 2));
      });
  };
  
  const getMatchingLetter = (letter) => {
    if (letter === 'ך') return 'כ';
    if (letter === 'ץ') return 'צ';
    if (letter === 'ף') return 'פ';
    if (letter === 'ן') return 'נ';
    if (letter === 'ם') return 'מ';
    return letter;
  };

  const getBookName = (bookNumber) => {
    switch (bookNumber) {
      case '1':
        return 'Genesis';
      case '2':
        return 'Exodus';
      case '3':
        return 'Leviticus';
      case '4':
        return 'Numbers';
      case '5':
        return 'Deuteronomy';
      default:
        return '';
    }
  };

  return (
    <div><strong>
      Type in a Hebrew word or a holy name below to find where in the Torah it is
      located by matching first letters.</strong>
      <p></p>
      <input type="text" onChange={handleInputChange} />
      <button onClick={searchPhrase}>Search</button>
      
      
      {fetchedData && ( 
        <div>
          <p>Torah Verse:</p>
           <p style={{ color: 'yellow' }}>{resultPhrase}</p>
          <p></p>
          <p style={{ color: 'yellow' }}>{JSON.parse(fetchedData).map((item, index) => (
            <p key={index}>{item.citation}</p>
          ))}</p>
        </div>
      )}
    </div>
  );
};

export default News;
